<template>
  <v-card dark :class="`pa-0 !border-0 !border-b-[1px] !rounded-b-none ${routeLink}-border `">
    <v-card-text class="pa-0">
      <v-container fluid class="">
        <v-row no-gutters class="align-center justify-between ">
          <v-col>
            <v-row v-if="!item.name" no-gutters class="">
              <v-skeleton-loader v-bind="attrs" type="list-item-avatar-two-line"
                class="skelton_for_header"></v-skeleton-loader>
            </v-row>
            <v-row no-gutters v-else class="justify-start align-center py-2 !flex-nowrap">
              <div class="!max-w-fit ml-2">
                <v-badge dot overlap bottom right bordered :color="presence !== 'offline' ? 'green' : 'grey'">
                  <v-avatar size="35">
                    <v-img :src="avatarImage" position="top center"></v-img>
                  </v-avatar>
                </v-badge>
              </div>
              <div class="ml-5">
                <h6 class="text-lg ma-0 font-Handel leading-none " :class="`${routeLink}_fortext`">{{ item.name }}</h6>
                <span class="font-Handel !text-xs">{{ status }}</span>
              </div>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
          <div class="me-3">
            <v-row no-gutters class="justify-evenly">
              <v-badge left overlap icon="mdi-crown-outline" :color="colorAsRoute" bordered avatar v-if="!premium">
                <span v-if="canShowAudioCall" :style="styles.audioCallOption" @click="openSubscribeToPremiumDialog()">
                </span>
              </v-badge>
              <span v-if="canShowAudioCall && premium" @click="emitAction('audioCall')">
                <Icon icon="ph:phone" :color="colorAsRoute" width="24" />
              </span>

              <v-badge left overlap icon="mdi-crown-outline" bordered avatar :color="colorAsRoute" v-if="!premium">
                <span v-if="canShowVideoCall" :style="styles.videoCallOption" @click="openSubscribeToPremiumDialog()"></span>
              </v-badge>

              <span v-if="canShowVideoCall && premium" @click="emitAction('videoCall')" class="ms-3">
                <Icon icon="ph:video-camera" :color="colorAsRoute" width="24" />
              </span>
            </v-row>
          </div>
        </v-row>
      </v-container>
    </v-card-text>
    <SubscribePremiumDialog />
   
  </v-card>
</template>

<!--eslint-disable-->
<script>
import dateFormat from "dateformat";

import {
  COMETCHAT_CONSTANTS,
  DEFAULT_STRING_PROP,
  DEFAULT_OBJECT_PROP,
  DEFAULT_BOOLEAN_PROP,
} from "../../../resources/constants";

import { cometChatCommon, propertyCheck, tooltip } from "../../../mixins/";
import { MessageHeaderManager } from "./controller";
import { SvgAvatar } from "../../../util/svgavatar";

import { CometChatAvatar, CometChatUserPresence } from "../../Shared";

import * as enums from "../../../util/enums.js";

import menuIcon from "./resources/menuicon.png";
import audioCallIcon from "./resources/audio.png";
import videoCallIcon from "./resources/video.png";
import detailPaneIcon from "./resources/detailpane.png";

import * as style from "./style";
import { Icon } from "@iconify/vue2";
import SubscribePremiumDialog from "@/components/settings/SubscribePremiumDialog.vue";

let messageHeaderManager;

/**
 * Displays message info in header.
 *
 * @displayName CometChatMessageHeader
 */
export default {
  name: "CometChatMessageHeader",
  mixins: [tooltip, propertyCheck, cometChatCommon],
  components: {
    CometChatAvatar,
    CometChatUserPresence,
    Icon,
    SubscribePremiumDialog
},
  props: {
    /**
     * The selected chat item object.
     */
    item: { ...DEFAULT_OBJECT_PROP },
    /**
     * Type of chat item.
     */
    type: { ...DEFAULT_STRING_PROP },
    /**
     * Theme of the UI.
     */

    theme: { ...DEFAULT_OBJECT_PROP },
    /**
     * Whether to show sidebar.
     */
    sidebar: { ...DEFAULT_BOOLEAN_PROP },
    /**
     * Current logged in user.
     */
    loggedInUser: { ...DEFAULT_OBJECT_PROP },
  },
  data() {
    return {
      // premium: true,

      status: "",
      presence: "offline",
    };
  },
  watch: {
    item: {
      /**
       * Watches item to update status message for group.
       */
      handler(newValue, oldValue) {
        if (messageHeaderManager) {
          messageHeaderManager.removeListeners();
        }
        messageHeaderManager = new MessageHeaderManager();
        messageHeaderManager.attachListeners(this.updateHeaderHandler);


        if (this.type === "user" && oldValue.uid !== newValue.uid) {
          this.setStatusForUser();
        } else if (
          this.type === "group" &&
          (newValue.guid !== oldValue.guid ||
            (newValue.guid === oldValue.guid &&
              newValue.membersCount !== oldValue.membersCount))
        ) {
          this.setStatusForGroup();
        }
      },
      deep: true,
    },
  },
  computed: {
    premiumLayout() {
      return this.$store.getters.isPremiumLayout
    },

    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    },
    /**
     * Icons computed from file images.
     */
    premium() {
      return this.$store.getters.isPremium;
    },
    styles() {
      return {
        name: style.chatNameStyle(),
        user: style.chatUserStyle(),
        detail: style.chatDetailStyle(),
        thumbnail: style.chatThumbnailStyle(),
        root: style.chatHeaderStyle(this.theme),
        optionWrapper: style.chatOptionWrapStyle(),
        sidebarBtn: style.chatSideBarBtnStyle(menuIcon, this.sidebar),
        audioCallOption: style.chatOptionStyle(audioCallIcon, "audio"),
        videoCallOption: style.chatOptionStyle(videoCallIcon, "video"),
        detailPaneOption: style.chatOptionStyle(detailPaneIcon, "detail"),
        status: style.chatStatusStyle(
          this.theme,
          this.presence,
          this.status,
          this.type
        ),
      };
    },
    /**
     * Computed avatar image
     */
    avatarImage() {
      const isUser = this.type === "user";
      const isItem = this.item;
      let avatar = isUser ? this.item.avatar : this.item.icon;
      if (!avatar) {
        if (this.item) {
          if (isUser) {
            avatar = SvgAvatar.getAvatar(
              this.item.uid,

              this.item.name.charAt(0).toUpperCase()
            );
          }
        }
      }
      return avatar;
    },
    /**
     * Returns if item is blocked by current user.
     */
    isBlockedByMe() {
      return this.item.blockedByMe;
    },
    /**
     * Returns if audio call icon can be shown.
     */
    canShowAudioCall() {
      return this.isBlockedByMe ? false : true;
    },
    /**
     * Returns if video call icon can be shown.
     */
    canShowVideoCall() {
      return this.isBlockedByMe ? false : true;
    },
  },
  methods: {
    /**
     * Sets status message for user
     */
   
    setStatusForUser() {
      let status = this.item.status;
      const presence = this.item.status === "online" ? "online" : "offline";

      if (this.item.status === "offline" && this.item.lastActiveAt) {
        status =
          COMETCHAT_CONSTANTS.LAST_ACTIVE_AT +
          dateFormat(this.item.lastActiveAt * 1000, "d mmmm yyyy, h:MM TT");
      } else if (this.item.status === "offline") {
        status = "offline";
      }

      this.status = status;
      this.presence = presence;
    },
    /**
     * Sets status message for group
     */
    setStatusForGroup() {
      this.status = `${this.item.membersCount} members`;
    },
    /**
     * Handles listener events
     */
    updateHeaderHandler(key, item, groupUser) {
      this.logInfo("CometChatMessageHeader: updateHeaderHandler", {
        key,
        item,
        groupUser,
      });
      switch (key) {
        case enums.USER_ONLINE:
        case enums.USER_OFFLINE: {
          if (this.type === "user" && this.item.uid === item.uid) {
            this.status = item.status;
            this.presence = item.status;
          }
          break;
        }
        case enums.GROUP_MEMBER_KICKED:
        case enums.GROUP_MEMBER_BANNED:
        case enums.GROUP_MEMBER_LEFT:
          if (
            this.type === "group" &&
            this.item.guid === item.guid &&
            this.loggedInUser.uid !== groupUser.uid
          ) {
            let membersCount = parseInt(item.membersCount);
            const status = `${membersCount} members`;

            this.status = status;
          }
          break;
        case enums.GROUP_MEMBER_JOINED:
          if (this.type === "group" && this.item.guid === item.guid) {
            let membersCount = parseInt(item.membersCount);
            const status = `${membersCount} members`;

            this.status = status;
          }
          break;
        case enums.GROUP_MEMBER_ADDED:
          if (this.type === "group" && this.item.guid === item.guid) {
            let membersCount = parseInt(item.membersCount);
            const status = `${membersCount} members`;

            this.status = status;
          }
          break;
        case enums.TYPING_STARTED: {
          if (
            this.type === "group" &&
            this.type === item.receiverType &&
            this.item.guid === item.receiverId
          ) {
            this.status = `${item.sender.name} ${COMETCHAT_CONSTANTS.IS_TYPING}`;
          } else if (
            this.type === "user" &&
            this.type === item.receiverType &&
            this.item.uid === item.sender.uid
          ) {
            this.status = COMETCHAT_CONSTANTS.TYPING;
          }
          break;
        }
        case enums.TYPING_ENDED: {
          if (
            this.type === "group" &&
            this.type === item.receiverType &&
            this.item.guid === item.receiverId
          ) {
            this.setStatusForGroup();
          } else if (
            this.type === "user" &&
            this.type === item.receiverType &&
            this.item.uid === item.sender.uid
          ) {
            if (this.presence === "online") {
              this.status = "online";
              this.presence = "online";
            } else {
              this.setStatusForUser();
            }
          }
          break;
        }
        default:
          break;
      }
    },
  },
  beforeMount() {
    messageHeaderManager = new MessageHeaderManager();
    messageHeaderManager.attachListeners(this.updateHeaderHandler);

    if (this.type === "user") {
      this.setStatusForUser();
    } else {
      this.setStatusForGroup();
    }
  },
  beforeDestroy() {
    if (this.messageHeaderManager) {
      this.messageHeaderManager.removeListeners();
      this.messageHeaderManager = null;
    }
  },
  beforeUnmount() {
    if (this.messageHeaderManager) {
      this.messageHeaderManager.removeListeners();
      this.messageHeaderManager = null;
    }
  },
};
</script>
<style scoped>
.cometchat_chat_option:first-of-type {
  margin-left: 0 !important;
}

.cometchat_chat_option:last-of-type {
  margin-right: 0 !important;
}

.skelton_for_header:deep(.v-skeleton-loader__list-item-avatar-two-line) {
  background: #000 !important;
  width: 200px;
}



.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.straight_cometchat_chat_icon {
  filter: invert(39%) sepia(32%) saturate(961%) hue-rotate(206deg) brightness(94%) contrast(95%);
}

.gay_cometchat_chat_icon {
  filter: invert(39%) sepia(32%) saturate(961%) hue-rotate(13deg) brightness(94%) contrast(95%);
}

.lesbian_cometchat_call_icon {
  filter: invert(39%) sepia(32%) saturate(961%) hue-rotate(13deg) brightness(94%) contrast(95%) !important;
}

.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
}


.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(39deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%);
}

.straight-border {
  border-color: #9a7006 !important;
}

.gay-border {
  border-color: #00a1c9 !important;
}

.lesbian-border {
  border-color: #9e2eec !important;
}
</style>
